export const alertStyle = {
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  actionText: {
    fontSize: '13px',
    fontWeight: '600',
  },
  alert: {
    marginTop: '32px',
    display: 'flex',
    alignItems: 'center',
  },
  action: {
    fontSize: '13px',
    cursor: 'pointer',
    marginRight: '24px',
  },
};
